import { i18n } from './i18n';

export function isoDateToFullDate(isoDate: string | Date | undefined) {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  const monthName = i18n.global.t(`date.months.${date.getMonth()}`).slice(0, 3);
  const day = date.getDate();
  const year = date.getFullYear();

  return `${day} ${monthName} ${year}`;
}

export function isoDateToFullDateTime(isoDate: string | Date | undefined) {
  if (!isoDate) return;
  const date = new Date(isoDate);
  const monthName = i18n.global.t(`date.months.${date.getMonth()}`).slice(0, 3);
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${day} ${monthName} ${year}, ${hours}:${minutes}`;
}

export function currentDateToISO(): string {
  const date = new Date();
  const dayOfWeek = date.getDay();

  if (dayOfWeek === 6) {
    date.setDate(date.getDate() - 1);
  } else if (dayOfWeek === 0) {
    // Sunday
    date.setDate(date.getDate() - 2);
  }

  return date.toISOString().slice(0, -1);
}

export function getCurrentTime() {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}

function isLeapYear(year: number) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

export function validateDatetime(datetime: string): boolean {
  const dateTimeRegex = /^(?:(\d{1,2})\/(\d{1,2})\/(\d{4})(?: (\d{2}):(\d{2}))?)|(\d{2}):(\d{2})$/; //DD/MM/YYYY HH:MM, D/M/YYYY HH:MM, DD/MM/YYYY, D/M/YYYY, HH:MM
  const match = datetime.match(dateTimeRegex);

  if (!match) {
    return false;
  }

  const today = new Date();
  let day: number | undefined, month: number | undefined, year: number | undefined;
  let hour: number | undefined, minute: number | undefined;

  if (match[1] && match[2] && match[3]) {
    day = Number(match[1]);
    month = Number(match[2]);
    year = Number(match[3]);
    if (match[4] && match[5]) {
      hour = Number(match[4]);
      minute = Number(match[5]);
    }
  } else if (match[6] && match[7]) {
    hour = Number(match[6]);
    minute = Number(match[7]);
  }

  if (year !== undefined) {
    if (year < 1915 || year > today.getFullYear() + 50) {
      return false;
    }

    if (month === undefined || month < 1 || month > 12) {
      return false;
    }

    const daysInMonth = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (day === undefined || day < 1 || day > daysInMonth[month - 1]) {
      return false;
    }
  }

  if (
    hour !== undefined &&
    (hour < 0 || hour > 23 || minute === undefined || minute < 0 || minute > 59)
  ) {
    return false;
  }

  return true;
}

export function isoDateToDatepickerFormat(isoDate?: string | Date) {
  if (!isoDate) isoDate = new Date().toISOString().split('T')[0] + 'T00:00:00';
  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/;
  if (!isoRegex.test(isoDate.toString())) return isoDate.toString();

  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function datepickerToServerDateFormat(date: string) {
  if (!date) return '';
  const [day, month, year] = date.split('/');

  return `${year}-${month}-${day}T00:00:00`;
}

function convertISOToDateObject(date: string) {
  const parts = date.split('T')[0].split('-');
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);

  return new Date(year, month, day);
}

export function compareDates(date1: string, date2: string, comparisonFnName: string): boolean {
  const dateObj1 = convertISOToDateObject(date1);
  const dateObj2 = convertISOToDateObject(date2);
  if (comparisonFnName == '>=') return dateObj1 >= dateObj2;

  return false;
}

export function parseDateManually(dateString: string): Date | null {
  if (!dateString) return null;

  const [datePart, timePart] = dateString.split(' ');
  const [day, month, year] = datePart.split('/').map(Number);
  const [hours, minutes] = timePart ? timePart.split(':').map(Number) : [0, 0];

  return new Date(year, month - 1, day, hours, minutes);
}
